import { render } from "./StopLoad.vue?vue&type=template&id=15f375e3"
import script from "./StopLoad.vue?vue&type=script&lang=js"
export * from "./StopLoad.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__